import React from "react";
import PropTypes from "prop-types";

import InformationalTooltip from "../InformationalTooltip";

const colors = ["#4c53d6", "#36d687", "#fe6f3f", "#50accb", "#ffcd3f"];

const TopProjects = ({ projects, topAmount, dark }) => (
  <div className="content-wrapper project-breakdown-container">
    <div className="header-section-container">
      <h1>{`Top ${topAmount} Projects`}</h1>
      <InformationalTooltip
        id="top_projects"
        dark={dark}
        content="Projects with the most hours applied"
      />
    </div>
    {projects.length > 0 &&
      projects.map((project, i) => (
        <div key={project._id} className="project-bar-container">
          <div className="project-bar-title">
            <h4>{`${project.project?.customer?.name}: `}</h4>
            <h5>{`${project.project?.description}`}</h5>
          </div>
          <div
            className="project-bar"
            style={{
              background: colors[i % colors.length],
              flexBasis: `calc(${
                (projects[i].billableHours / projects[0].billableHours) * 100
              }% - 150px)`
            }}
          >
            <span>
              {project.numCalls}{" "}
              {`${project.numCalls === 1 ? "Call" : "Calls"}`}
            </span>

            <span className="percentage">{project.billableHours} HRS</span>
          </div>
        </div>
      ))}

    {projects.length === 0 && (
      <div className="no-projects-container">
        <h4>No Data To Show</h4>
      </div>
    )}
  </div>
);

TopProjects.propTypes = {
  projects: PropTypes.array,
  topAmount: PropTypes.number,
  dark: PropTypes.bool
};

TopProjects.defaultProps = {
  projects: [],
  topAmount: 5,
  dark: false
};

export default TopProjects;
